import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import dayjs from 'dayjs'

import PATUsageGuide from './PATUsageGuide.vue'
import { api } from '../adminApi'
import { GetTokenResponse } from '../generated/api'



export default /*#__PURE__*/_defineComponent({
  __name: 'PATListEntry',
  props: {
    email: null,
    pat: null
  },
  emits: ["refresh"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'refresh'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  email: string,
  pat: GetTokenResponse,
}






const useDialogVisible = ref(false)

function copyTextToClipboard(text: string) {
  navigator.clipboard.writeText(text)
}

async function revoke() {

  try {
    await api.deleteToken(props.pat.token)
  } catch (error) {
    console.log(error)
  }

  emit('refresh')
}

function patUsageGuideDone() {
  useDialogVisible.value = false
}

function abbreviateToken(token: string): string {
  if (token.length > 8) {
    return `${token.slice(0, 4)}...${token.slice(-4)}`
  } else {
    return token
  }
}

function timestampToDisplayString(timestamp: string): string {
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm')
}


return { __sfc: true,props, emit, useDialogVisible, copyTextToClipboard, revoke, patUsageGuideDone, abbreviateToken, timestampToDisplayString, PATUsageGuide }
}

})